const CONDITION_ALIASES: Record<string, string> = {
  greater_than: "is_greater_than",
  greater_than_or_equals_to: "is_greater_than_or_equal_to",
  less_than: "is_less_than",
  less_than_or_equals_to: "is_less_than_or_equal_to",
};

const normalizeToken = (value: string | null | undefined): string =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_");

export const normalizeTargetingCondition = (
  condition: string | null | undefined,
): string => {
  const normalized = normalizeToken(condition);
  return CONDITION_ALIASES[normalized] || normalized;
};

export const normalizeTargetingOption = (
  option: string | null | undefined,
): string => normalizeToken(option);
